"use strict";import{userFocusableSelector as t}from"./focusable-selectors.js";export const firstFocusableIn=e=>e.querySelector(t),firstFocusableSlottedIn=e=>e.assignedElements().find(o=>o.matches(t));
//# sourceMappingURL=first-focusable-in.js.map
